import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { PaymentMode } from "../payment-mode/payment-mode.entity";
import { ShippingTerms } from "../shipping-terms/shipping-terms.entity";
import { Address } from "./address.entity";

@Entity('customers')
export class Customers {

  @PrimaryGeneratedColumn("increment",{name:'cust_id'})
  custId:number;
  @Column("varchar",{
    nullable:false,
    length:15,
    name:"client_code"
    })
  clientCode:string;
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"client_name"
      })
  @Index({unique:true})
    clientName:string;
  @Column("varchar",{
        nullable:false,
        length:50,
        name:"account_type"
        })
     accountType:string;
  @Column("varchar",{
      nullable:true,
      length:20,
      name:"gst_number"
      })
    gstNumber:string;
  @Column("varchar",{
      nullable:true,
      length:25,
      name:"website"
      })
  website:string;
  
  @Column("varchar",{
      nullable:true,
      length:50,
      name:"contact_person"
      })
  contactPerson:string;
  @Column("varchar",{
      nullable:false,
      length:10,
      name:"phone_no"
      })
  phoneNo:string;
  @Column("varchar",{
      nullable:true,
      length:30,
      name:"email"
      })
    email:string;
//   @Column("varchar",{
//       nullable:false,
//       length:40,
//       name:"street"
//       })
//     street:string;
//   @Column("varchar",{
//       nullable:false,
//       length:30,
//       name:"appartment"
//       })
//       appartment:string;
//   @Column("varchar",{
//       nullable:false,
//       length:30,
//       name:"city"
//       })
//       city:string;
//   @Column("varchar",{
//       nullable:false,
//       length:40,
//       name:"state"
//       })
//       state:string;
//   @Column("varchar",{
//       nullable:false,
//       length:10,
//       name:"postal_code"
//       })
//       postalCode:string;
  @Column("varchar",{
      nullable:false,
      length:15,
      name:"currency"
      })
      currency:string;
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"payment_terms"
      })
      paymentTerms:string;
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"shipment_terms"
      })
      shipmentTerms:string;
  @Column("int",{
     nullable:false,
     name:"payment_mode_id"
     })
     paymentModeId:number;
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"rate_per_hour"
      })
      ratePerHour:string;
  @Column("varchar",{
      nullable:true,
      length:50,
      name:"public_note"
      })
      publicNote:string;
  @Column("varchar",{
      nullable:true,
      length:50,
      name:"privateNote"
      })
      privateNote:string;
  @Column("int",{
      nullable:false,
      name:"country_id"
      })
      countryId:number;
    //   @Column("varchar",{
    //     nullable:false,
    //     name:"customer_account_type"
    //     })
    //     customerAccountType:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "ADMIN",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ApiProperty({type:[Address]})

  @OneToMany(type => Address, cusAddress => cusAddress.customerInfo, { cascade: true })
  cusAddressInfo: Address[];
//   @ManyToOne(type=>PaymentMode, paymentMode=>paymentMode.paymentModeId,{  nullable:false, })
//     @JoinColumn({ name:"payment_mode_id"})
//     paymentModeInfo: PaymentMode;
//   @ManyToOne(type=>ShippingTerms, shippingTerms=>shippingTerms.shippingTermsId,{  nullable:false, })
//     @JoinColumn({ name:"shipment_terms"})
//     shippingTermsInfo: ShippingTerms;
   

}
